import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { _ as _to_consumable_array } from "@swc/helpers/_/_to_consumable_array";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useState, useEffect, useMemo, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import { Formik } from "formik";
import * as yup from "yup";
import Select from "react-select";
import { ReactSearchAutocomplete } from "react-search-autocomplete";
import ColumnResizer from "react-table-column-resizer";
import { nanoid } from "nanoid";
import Dropdown from "react-bootstrap/Dropdown";
import { ModalAllder } from "layouts/ModalAllder";
import { NumericFormat } from "react-number-format";
import { useReactToPrint } from "react-to-print";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
// import DatePicker from "react-datepicker";
import { DndContext, closestCenter, KeyboardSensor, useSensor, useSensors, MouseSensor, TouchSensor } from "@dnd-kit/core";
import { restrictToVerticalAxis } from "@dnd-kit/modifiers";
import { arrayMove, SortableContext, verticalListSortingStrategy, useSortable } from "@dnd-kit/sortable";
import { useAppDispatch, useAppSelector } from "../../../redux/store/configureStore";
import { useGlobalModalContext } from "contexts/GlobalModalContext";
import { useGlobalLoaderContext } from "contexts/GlobalLoaderContext";
import moment from "moment";
import { isReadyToPrint, NumberFormat, WDA, getDiscountValue, calPriceByMstCategoryPriceTax, setProductRowVatByMstCategoryPrice, NumberFormatFloat, isOverDue } from "utils/HelperFunction";
import dayjs from "dayjs";
import { ProductTableDisplay } from "layouts/ProductTableDisplay";
import { grVerifyCases } from "utils/HelperGrFunction";
import DocStatus from "layouts/DocStatus";
import { getAllMstPriceCategory } from "../../../redux/handlers/master/getAllMstPriceCategory.handler";
import { getAllMstDiscountType } from "../../../redux/handlers/master/getAllMstDiscountType.handler";
import { getUserInfo } from "../../../redux/handlers/auth/getUserInfo.handler";
import { getAllSupplierInformation } from "../../../redux/handlers/logic/getAllSupplierInformation.handler";
import { getAllMstVat } from "../../../redux/handlers/master/getAllMstVat.handler";
import { genExpenseDocNumber } from "../../../redux/handlers/logic/genExpenseDocNumber.handler";
import { mappingExpense } from "utils/HelperExpenseFunction";
import { initState } from "mocks/expenseData";
import { getExpenseById } from "../../../redux/handlers/logic/getExpenseById.handler";
import { getAllMstAddCost } from "../../../redux/handlers/master/getAllMstAddCost.handler";
import { getAllMstAddCostUnit } from "../../../redux/handlers/master/getAllMstAddCostUnit.handler";
import { Popover } from "@mui/material";
import CurrencyInput from "react-currency-input-field";
import { getAllMstWithholdingTax } from "../../../redux/handlers/master/getAllMstWithholdingTax.handler";
import { clearUpdateExpense, updateExpense } from "../../../redux/handlers/logic/updateExpense.handler";
import ExpStatus from "fragments/ExpStatus";
import { clearCreateExpense, createExpense } from "../../../redux/handlers/logic/createExpense.handler";
import DiscountInput from "fragments/DiscountInput";
export function ExpenseCreate() {
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var _useGlobalLoaderContext = useGlobalLoaderContext(), isloading = _useGlobalLoaderContext.isloading, setIsLoading = _useGlobalLoaderContext.setIsLoading;
    var _useParams = useParams(), action = _useParams.action, dataID = _useParams.dataID;
    var _useState = _sliced_to_array(useState([]), 2), productRow = _useState[0], setProductRow = _useState[1];
    var _useState1 = _sliced_to_array(useState(0), 2), sumproductPrice = _useState1[0], setSumproductPrice = _useState1[1];
    var _useState2 = _sliced_to_array(useState(0), 2), sumproductNoVat = _useState2[0], setSumproductNoVat = _useState2[1];
    var _useState3 = _sliced_to_array(useState(0), 2), sumproductZeroVat = _useState3[0], setSumproductZeroVat = _useState3[1];
    var _useState4 = _sliced_to_array(useState(0), 2), sumproductSevenVat = _useState4[0], setSumproductSevenVat = _useState4[1];
    var _useState5 = _sliced_to_array(useState(0), 2), sumproductBeforeVat = _useState5[0], setSumproductBeforeVat = _useState5[1];
    var _useState6 = _sliced_to_array(useState(0), 2), sumProductReceivedQuantity = _useState6[0], setSumProductReceivedQuantity = _useState6[1];
    var _useState7 = _sliced_to_array(useState(0), 2), sumProductBalanceQuantity = _useState7[0], setSumProductBalanceQuantity = _useState7[1];
    var _useState8 = _sliced_to_array(useState(0), 2), sumProductReceiveQuantity = _useState8[0], setSumProductReceiveQuantity = _useState8[1];
    var _useState9 = _sliced_to_array(useState([]), 2), updateDocIds = _useState9[0], setUpdateDocIds = _useState9[1];
    var _useState10 = _sliced_to_array(useState({
        columnsort: [
            {
                id: "",
                sortKey: ""
            },
            {
                id: "",
                sortKey: ""
            },
            {
                id: "",
                sortKey: ""
            }
        ],
        type: "select"
    }), 2), columnsort = _useState10[0], setColumnsort = _useState10[1];
    var schema = yup.object().shape({
        dim_mst_price_category_id: yup.string().required(),
        dim_supplier_information_id: yup.string().required(),
        doc_due_date: yup.date().required(),
        doc_issue_date: yup.string().required(),
        fact_expense_items: yup.array().of(yup.object().shape({
            dim_mst_add_cost_id: yup.string().required(),
            quantity: yup.string().required(),
            unit_price: yup.string().required(),
            dim_mst_add_cost_unit_id: yup.string().required(),
            dim_mst_vat_id: yup.string().required()
        })),
        dim_mst_expense_status_id: yup.string().required()
    });
    var _useState11 = _sliced_to_array(useState(false), 2), formdisabled = _useState11[0], setFormdisabled = _useState11[1];
    var _useState12 = _sliced_to_array(useState(initState), 2), formdata = _useState12[0], setFormdata = _useState12[1];
    var _useState13 = _sliced_to_array(useState(), 2), docExpenseNumber = _useState13[0], setDocExpenseNumber = _useState13[1];
    var _useState14 = _sliced_to_array(useState({
        id: "",
        dimGroupOfSupplierCode: "",
        full_supplier_name: "-",
        initials: "-",
        company_branch_code: "",
        company_branch_name: "",
        full_supplier_address_name: "-",
        company_phone_number: "-"
    }), 2), pdata = _useState14[0], setPdata = _useState14[1];
    var _useState15 = _sliced_to_array(useState(1), 2), tab = _useState15[0], setTab = _useState15[1];
    var _useState16 = _sliced_to_array(useState({
        productQtyNotMatch: false,
        productQtyNotMatchAccept: false,
        InputInvalid: false,
        InputInvalidAccept: false
    }), 2), alert = _useState16[0], setAlert = _useState16[1];
    var _useState17 = _sliced_to_array(useState({
        open: false,
        x: 0,
        y: 0,
        width: 360,
        height: 320,
        pin: false,
        mode: "normal",
        modalname: "success"
    }), 2), modalSuccess = _useState17[0], setModalSuccess = _useState17[1];
    var _useState18 = _sliced_to_array(useState({
        open: false,
        x: 0,
        y: 0,
        width: 360,
        height: 320,
        pin: false,
        mode: "normal",
        modalname: "savesuccess2"
    }), 2), modalSaveSuccess = _useState18[0], setModalSaveSuccess = _useState18[1];
    var _useState19 = _sliced_to_array(useState({
        open: false,
        x: 0,
        y: 0,
        width: 460,
        height: 410,
        pin: false,
        mode: "normal",
        modalname: "apsuccess2"
    }), 2), modalApproveSuccess = _useState19[0], setModalApproveSuccess = _useState19[1];
    var _useState20 = _sliced_to_array(useState({
        open: false,
        x: 0,
        y: 0,
        width: 460,
        height: 410,
        pin: false,
        mode: "normal",
        modalname: "apsuccess2"
    }), 2), modalNotApprove = _useState20[0], setModalNotApprove = _useState20[1];
    var _useState21 = _sliced_to_array(useState({
        open: false,
        x: 0,
        y: 0,
        width: 460,
        height: 310,
        pin: false,
        mode: "normal",
        modalname: "apsuccess2"
    }), 2), modalAlert = _useState21[0], setModalAlert = _useState21[1];
    var _useState22 = _sliced_to_array(useState({
        open: false,
        x: 0,
        y: 0,
        width: 500,
        height: 400,
        pin: false,
        mode: "normal",
        modalname: "product-verify"
    }), 2), modalVerifyInformation = _useState22[0], setModalVerifyInformation = _useState22[1];
    var genExpenseDocNumberReducer = useAppSelector(function(state) {
        return state.genExpenseDocNumberReducer;
    });
    var _useState23 = _sliced_to_array(useState([]), 2), supplierInfos = _useState23[0], setSupplierInfos = _useState23[1];
    var getAllSupplierInformationReducer = useAppSelector(function(state) {
        return state.getAllSupplierInformationReducer;
    });
    useEffect(function() {
        setIsLoading(genExpenseDocNumberReducer.isFetching || getAllSupplierInformationReducer.isFetching);
        if (genExpenseDocNumberReducer.data && action === "create") {
            setFormdata(function(prev) {
                return _object_spread_props(_object_spread({}, prev), {
                    doc_number: genExpenseDocNumberReducer.data.data
                });
            });
        }
        if (getAllSupplierInformationReducer.data) {
            setSupplierInfos(getAllSupplierInformationReducer.data.data);
        }
    }, [
        genExpenseDocNumberReducer,
        getAllSupplierInformationReducer
    ]);
    var _useState24 = _sliced_to_array(useState("สร้างใบบันทึกค่าใช้จ่าย"), 2), headerName = _useState24[0], setheaderName = _useState24[1];
    var _useState25 = _sliced_to_array(useState({
        isCreate: true,
        isEdit: false
    }), 2), caseController = _useState25[0], setCaseController = _useState25[1];
    useEffect(function() {
        if (dataID && action === "create") {
            setCaseController(function(prev) {
                return _object_spread_props(_object_spread({}, prev), {
                    isCreate: true,
                    isEdit: false
                });
            });
            setheaderName("สร้างใบบันทึกค่าใช้จ่าย");
        } else if (dataID && action === "edit") {
            setCaseController(function(prev) {
                return _object_spread_props(_object_spread({}, prev), {
                    isCreate: false,
                    isEdit: true
                });
            });
            setheaderName("แก้ไขใบบันทึกค่าใช้จ่าย");
        }
    }, [
        dataID,
        action
    ]);
    var componentRef = useRef();
    var handlePrint = useReactToPrint({
        content: function() {
            return componentRef.current;
        }
    });
    var _useState26 = _sliced_to_array(useState({
        open: false,
        x: 0,
        y: 0,
        width: 460,
        height: 360,
        pin: false,
        mode: "normal",
        modalname: "apsuccess2"
    }), 2), modalConfirmCancel = _useState26[0], setModalConfirmCancel = _useState26[1];
    var formatResult = function(item) {
        return /*#__PURE__*/ _jsxs("div", {
            className: "",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    children: item.full_supplier_name
                }),
                /*#__PURE__*/ _jsx("div", {
                    style: {
                        color: "#8E8E8F"
                    },
                    children: item.initials
                })
            ]
        }, item.id);
    };
    var getData = function() {
        dispatch(getExpenseById(dataID, {
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
    };
    var loadAllMsts = function() {
        dispatch(getAllMstWithholdingTax());
        dispatch(getAllMstPriceCategory());
        dispatch(getAllMstDiscountType());
        dispatch(getAllMstVat());
        dispatch(getAllMstAddCost());
        dispatch(getAllMstAddCostUnit());
    };
    var loadAllResources = function() {
        dispatch(getUserInfo({
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
        if (!dataID) {
            dispatch(genExpenseDocNumber({
                modalObj: modalObj,
                setModalObj: setModalObj
            }));
        }
        dispatch(getAllSupplierInformation({
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
    };
    var _useState27 = _sliced_to_array(useState([]), 2), optionsMstPriceCategory = _useState27[0], setOptionsMstPriceCategory = _useState27[1];
    var _useState28 = _sliced_to_array(useState([]), 2), optionsMstDiscountType = _useState28[0], setOptionsMstDiscountType = _useState28[1];
    var _useState29 = _sliced_to_array(useState([]), 2), optionsMstVat = _useState29[0], setOptionsMstVat = _useState29[1];
    var _useState30 = _sliced_to_array(useState([]), 2), optionsNewItemExpenseCol = _useState30[0], setOptionsNewItemExpenseCol = _useState30[1];
    var _useState31 = _sliced_to_array(useState([]), 2), optionsMstAddCost = _useState31[0], setOptionsMstAddCost = _useState31[1];
    var _useState32 = _sliced_to_array(useState([]), 2), optionsMstWithholdingTax = _useState32[0], setOptionsMstWithholdingTax = _useState32[1];
    var _useState33 = _sliced_to_array(useState([]), 2), optionsMstAddCostUnit = _useState33[0], setOptionsMstAddCostUnit = _useState33[1];
    var _useState34 = _sliced_to_array(useState(), 2), userInfo = _useState34[0], setUserInfo = _useState34[1];
    var getAllMstWithholdingTaxReducer = useAppSelector(function(state) {
        return state.getAllMstWithholdingTaxReducer;
    });
    var getAllMstPriceCategoryReducer = useAppSelector(function(state) {
        return state.getAllMstPriceCategoryReducer;
    });
    var getAllMstDiscountTypeReducer = useAppSelector(function(state) {
        return state.getAllMstDiscountTypeReducer;
    });
    var getAllMstVatReducer = useAppSelector(function(state) {
        return state.getAllMstVatReducer;
    });
    var getAllMstAddCostReducer = useAppSelector(function(state) {
        return state.getAllMstAddCostReducer;
    });
    var getAllMstAddCostUnitReducer = useAppSelector(function(state) {
        return state.getAllMstAddCostUnitReducer;
    });
    var getUserInfoReducer = useAppSelector(function(state) {
        return state.getUserInfoReducer;
    });
    var getExpenseByIdReducer = useAppSelector(function(state) {
        return state.getExpenseByIdReducer;
    });
    var createExpenseReducer = useAppSelector(function(state) {
        return state.createExpenseReducer;
    });
    var updateExpenseReducer = useAppSelector(function(state) {
        return state.updateExpenseReducer;
    });
    useEffect(function() {
        loadAllMsts();
        loadAllResources();
    }, []);
    useEffect(function() {
        setIsLoading(getAllMstAddCostReducer.isFetching || getAllMstWithholdingTaxReducer.isFetching || getAllMstAddCostUnitReducer.isFetching || getAllMstPriceCategoryReducer.isFetching || getAllMstDiscountTypeReducer.isFetching || getAllMstVatReducer.isFetching || getUserInfoReducer.isFetching);
        if (getAllMstWithholdingTaxReducer.data) {
            setOptionsMstWithholdingTax(getAllMstWithholdingTaxReducer.data.data.map(function(item) {
                return {
                    label: item.name,
                    value: item.id,
                    vat: item.value
                };
            }));
        }
        if (getAllMstAddCostReducer.data) {
            setOptionsMstAddCost(getAllMstAddCostReducer.data.data.map(function(item) {
                return {
                    label: item.name,
                    value: item.id
                };
            }));
        }
        if (getAllMstAddCostUnitReducer.data) {
            setOptionsMstAddCostUnit(getAllMstAddCostUnitReducer.data.data.map(function(item) {
                return {
                    label: item.name,
                    value: item.id
                };
            }));
        }
        if (getUserInfoReducer.data) {
            setUserInfo(getUserInfoReducer.data.data);
        }
        if (getAllMstPriceCategoryReducer.data) {
            setOptionsMstPriceCategory(getAllMstPriceCategoryReducer.data.data.map(function(item) {
                return {
                    label: item.name,
                    value: item.id
                };
            }));
        }
        if (getAllMstDiscountTypeReducer.data) {
            setOptionsMstDiscountType(getAllMstDiscountTypeReducer.data.data.map(function(item) {
                return {
                    label: item.name,
                    value: item.id
                };
            }));
        }
        if (getAllMstVatReducer.data) {
            setOptionsMstVat(getAllMstVatReducer.data.data.map(function(item) {
                return {
                    label: item.name,
                    value: item.id,
                    vat: item.value
                };
            }));
        }
    }, [
        getAllMstAddCostReducer,
        getAllMstAddCostUnitReducer,
        getAllMstPriceCategoryReducer,
        getAllMstDiscountTypeReducer,
        getAllMstVatReducer,
        getUserInfoReducer,
        getAllMstWithholdingTaxReducer
    ]);
    useEffect(function() {
        if (dataID) {
            getData();
            setheaderName("แก้ไขใบบันทึกค่าใช้จ่าย");
        } else {
            setFormdata(initState);
        }
    }, [
        dataID
    ]);
    useEffect(function() {
        setIsLoading(getExpenseByIdReducer.isFetching);
        if (getExpenseByIdReducer.data && !getExpenseByIdReducer.isError && dataID) {
            var expenseData = getExpenseByIdReducer.data.data;
            if (!expenseData) {
                return navigate("/404", {
                    replace: true
                });
            }
            var dataWithReplacements = mappingExpense({
                expenseData: expenseData,
                setPdata: setPdata,
                setProductRow: setProductRow,
                setFormdisabled: setFormdisabled,
                columnsort: columnsort,
                setColumnsort: setColumnsort
            });
            setFormdata(dataWithReplacements);
        }
    }, [
        getExpenseByIdReducer
    ]);
    useEffect(function() {
        setIsLoading(updateExpenseReducer.isFetching);
        if (updateExpenseReducer.data && !updateExpenseReducer.isError) {
            getData();
            setModalSuccess(function(prev) {
                return _object_spread_props(_object_spread({}, prev), {
                    open: true
                });
            });
            dispatch(clearUpdateExpense());
        }
    }, [
        updateExpenseReducer
    ]);
    useEffect(function() {
        setIsLoading(createExpenseReducer.isFetching);
        if (createExpenseReducer.data && !createExpenseReducer.isError) {
            setModalSuccess(function(prev) {
                return _object_spread_props(_object_spread({}, prev), {
                    open: true
                });
            });
            setFormdisabled(true);
            dispatch(clearCreateExpense());
            var createdData = createExpenseReducer.data.data;
            var id = createdData && createdData.id ? createdData.id : null;
            if (id) {
                navigate("/financial-accounting/expense/edit/".concat(id));
            } else {
                navigate("/financial-accounting/expenses");
            }
        }
    }, [
        createExpenseReducer
    ]);
    return /*#__PURE__*/ _jsxs("div", {
        className: "document-page",
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "pagezoom",
                children: [
                    /*#__PURE__*/ _jsx("nav", {
                        "aria-label": "breadcrumb",
                        className: "mt-1",
                        children: /*#__PURE__*/ _jsxs("ol", {
                            className: "breadcrumb fs-16 ps-0",
                            children: [
                                /*#__PURE__*/ _jsx("li", {
                                    className: "breadcrumb-item",
                                    children: /*#__PURE__*/ _jsx("a", {
                                        href: "#",
                                        className: "tc-7  text-decoration-none",
                                        children: "การเงินและบัญชี"
                                    })
                                }),
                                /*#__PURE__*/ _jsx("li", {
                                    className: "breadcrumb-item",
                                    children: /*#__PURE__*/ _jsx("a", {
                                        href: "#",
                                        className: "tc-7  text-decoration-none",
                                        children: "ใบบันทึกค่าใช้จ่าย"
                                    })
                                }),
                                /*#__PURE__*/ _jsxs("li", {
                                    className: "breadcrumb-item active tc-1 ",
                                    "aria-current": "page",
                                    children: [
                                        headerName,
                                        " "
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "fs-24 mb-4",
                        children: headerName
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(Formik, {
                enableReinitialize: true,
                initialValues: formdata,
                validationSchema: schema,
                validateOnMount: true,
                onSubmit: function(values) {
                    var _loop = function(key) {
                        if (Object.hasOwnProperty.call(values, key)) {
                            var value = values[key];
                            if (key === "fact_expense_items" && value) {
                                formdataPayload.append(key, JSON.stringify(value));
                            } else if (Array.isArray(value)) {
                                value.forEach(function(item) {
                                    return formdataPayload.append(key, item);
                                });
                            } else if (value !== undefined) {
                                formdataPayload.append(key, value);
                            }
                        }
                    };
                    var formdataPayload = new FormData();
                    for(var key in values)_loop(key);
                    // console.log(formdataPayload);
                    if (!dataID) {
                        dispatch(createExpense(formdataPayload, {
                            modalObj: modalObj,
                            setModalObj: setModalObj
                        }));
                    } else {
                        dispatch(updateExpense(dataID, formdataPayload, {
                            modalObj: modalObj,
                            setModalObj: setModalObj
                        }));
                    }
                },
                children: function(param) {
                    var handleSubmit = param.handleSubmit, handleChange = param.handleChange, touched = param.touched, errors = param.errors, values = param.values, setFieldValue = param.setFieldValue, setValues = param.setValues, setErrors = param.setErrors, setTouched = param.setTouched, isInvalid = param.isInvalid, isValid = param.isValid;
                    return /*#__PURE__*/ _jsxs(Form, {
                        noValidate: true,
                        onSubmit: function(e) {
                            e.preventDefault();
                            var product = productRow.filter(function(prev) {
                                return prev.productID;
                            });
                            if (product && product.length > 0) {
                                var newItems = product.map(function(v) {
                                    return {
                                        dim_mst_add_cost_id: v.productID,
                                        quantity: v.productQty,
                                        unit_price: v.productPrice,
                                        dim_mst_add_cost_unit_id: v.productUnitID,
                                        dim_mst_discount_type_id: v.discountType,
                                        discount_value: v.discountType === 1 ? v.discountPercent : v.discount,
                                        dim_mst_vat_id: v.dim_mst_vat_id,
                                        dim_mst_withholding_tax_id: v.dim_mst_withholding_tax_id,
                                        remark: v.note
                                    };
                                });
                                schema.validate(_object_spread_props(_object_spread({}, values), {
                                    fact_expense_items: newItems
                                }), {
                                    abortEarly: false
                                }).then(function() {
                                    setFieldValue("fact_expense_items", newItems);
                                    handleSubmit();
                                }).catch(function(err) {
                                    console.log(err);
                                    console.log(newItems);
                                });
                            } else {
                                setModalAlert(function(prev) {
                                    return _object_spread_props(_object_spread({}, prev), {
                                        open: true
                                    });
                                });
                            }
                        },
                        children: [
                            /*#__PURE__*/ _jsx("fieldset", {
                                disabled: formdisabled,
                                children: /*#__PURE__*/ _jsx("div", {
                                    className: "card pagezoom card-st-3 mb-4",
                                    style: {
                                        minWidth: "1000px"
                                    },
                                    children: /*#__PURE__*/ _jsx("div", {
                                        className: "card-body px-xl-3",
                                        children: /*#__PURE__*/ _jsx("div", {
                                            id: "",
                                            children: /*#__PURE__*/ _jsx("div", {
                                                children: /*#__PURE__*/ _jsxs("div", {
                                                    className: "pt-3 px-3",
                                                    children: [
                                                        /*#__PURE__*/ _jsx("div", {
                                                            className: "row row gx-xl-4",
                                                            children: /*#__PURE__*/ _jsxs("div", {
                                                                className: "col-12",
                                                                children: [
                                                                    !dataID && /*#__PURE__*/ _jsx("div", {
                                                                        className: "d-flex justify-content-end align-items-center h-100",
                                                                        children: /*#__PURE__*/ _jsx("div", {
                                                                            children: /*#__PURE__*/ _jsx(ExpStatus, {
                                                                                statusID: 1,
                                                                                statusName: "แบบร่าง"
                                                                            })
                                                                        })
                                                                    }),
                                                                    dataID && values.dimMstExpenseStatus && /*#__PURE__*/ _jsx("div", {
                                                                        className: "d-flex justify-content-end align-items-center h-100",
                                                                        children: /*#__PURE__*/ _jsx("div", {
                                                                            children: /*#__PURE__*/ _jsx(ExpStatus, {
                                                                                statusID: isOverDue(values.doc_due_date) ? "overdue" : values.dimMstExpenseStatus.id,
                                                                                statusName: isOverDue(values.doc_due_date) ? "เกินกำหนด" : values.dimMstExpenseStatus.name
                                                                            })
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ _jsxs("div", {
                                                            className: "row gx-xl-4",
                                                            children: [
                                                                /*#__PURE__*/ _jsx("div", {
                                                                    className: "col-3",
                                                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                        className: "mb-2 form-st-3 pb-1",
                                                                        children: [
                                                                            /*#__PURE__*/ _jsxs(Form.Label, {
                                                                                className: "mb-1",
                                                                                children: [
                                                                                    "เลขที่เอกสาร",
                                                                                    " "
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ _jsx(Form.Control, {
                                                                                type: "text",
                                                                                name: "doc_number",
                                                                                className: "form-control",
                                                                                placeholder: "",
                                                                                value: values.doc_number,
                                                                                onChange: handleChange,
                                                                                disabled: true
                                                                            })
                                                                        ]
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ _jsx("div", {
                                                                    className: "col-3",
                                                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                        className: "mb-2 form-st-3 pb-1",
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                                                className: "mb-1",
                                                                                children: "อ้างอิงจากระบบ"
                                                                            }),
                                                                            /*#__PURE__*/ _jsx(Form.Control, {
                                                                                type: "text",
                                                                                className: "form-control",
                                                                                placeholder: "",
                                                                                value: values.gr_refer,
                                                                                disabled: true
                                                                            })
                                                                        ]
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ _jsx("div", {
                                                                    className: "col-2",
                                                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                        className: "mb-2 form-st-3 pb-1",
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                                                className: "mb-1",
                                                                                children: "เอกสารอ้างอิง"
                                                                            }),
                                                                            /*#__PURE__*/ _jsx(Form.Control, {
                                                                                type: "text",
                                                                                name: "doc_refer",
                                                                                className: "form-control",
                                                                                placeholder: "เพิ่มเลขเอกสาร",
                                                                                value: values.doc_refer,
                                                                                onChange: handleChange,
                                                                                isInvalid: !!errors.doc_refer
                                                                            })
                                                                        ]
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ _jsx("div", {
                                                                    className: "col-2",
                                                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                        className: "mb-2 form-st-3 pb-1",
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                                                className: "mb-1",
                                                                                children: "เลขที่ใบกำกับ"
                                                                            }),
                                                                            /*#__PURE__*/ _jsx(Form.Control, {
                                                                                type: "text",
                                                                                name: "tax_invoice_number",
                                                                                className: "form-control",
                                                                                placeholder: "เพิ่มเลขที่ใบกำกับ",
                                                                                value: values.tax_invoice_number,
                                                                                onChange: handleChange,
                                                                                isInvalid: !!errors.tax_invoice_number
                                                                            })
                                                                        ]
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ _jsx("div", {
                                                                    className: "col-2",
                                                                    children: /*#__PURE__*/ _jsx(Form.Group, {
                                                                        className: "   mt-[12px]",
                                                                        children: /*#__PURE__*/ _jsx(LocalizationProvider, {
                                                                            dateAdapter: AdapterDayjs,
                                                                            className: "h-[40px] ",
                                                                            children: /*#__PURE__*/ _jsx(DatePicker, {
                                                                                format: "DD/MM/YYYY",
                                                                                slotProps: {
                                                                                    textField: {
                                                                                        InputLabelProps: {
                                                                                            shrink: true
                                                                                        },
                                                                                        error: !!errors.tax_invoice_date
                                                                                    }
                                                                                },
                                                                                label: "วันที่เอกสาร/ใบกำกับภาษี",
                                                                                className: "h-[40px] w-full ",
                                                                                sx: {
                                                                                    ".MuiInputBase-formControl": {
                                                                                        height: "53px",
                                                                                        borderRadius: "8px"
                                                                                    },
                                                                                    ".MuiFormLabel-root": {
                                                                                        fontFamily: "Sarabun"
                                                                                    },
                                                                                    ".MuiOutlinedInput-notchedOutline": {
                                                                                        border: "1px solid rgba(76, 78, 100, 0.22)"
                                                                                    }
                                                                                },
                                                                                name: "tax_invoice_date",
                                                                                value: values.tax_invoice_date ? dayjs(values.tax_invoice_date) : null,
                                                                                onChange: function(date) {
                                                                                    var formattedDate = dayjs(date).isValid() ? dayjs(date).format("YYYY-MM-DD") : null;
                                                                                    setFieldValue("tax_invoice_date", formattedDate);
                                                                                }
                                                                            })
                                                                        })
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ _jsx("div", {
                                                                    className: "col-6",
                                                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                        className: "mb-2 form-st-3 pb-1",
                                                                        children: [
                                                                            /*#__PURE__*/ _jsxs(Form.Label, {
                                                                                className: "mb-1",
                                                                                style: {
                                                                                    zIndex: 11
                                                                                },
                                                                                children: [
                                                                                    "ผู้จัดจำหน่าย",
                                                                                    " ",
                                                                                    /*#__PURE__*/ _jsx("span", {
                                                                                        className: "text-[#FF0000]",
                                                                                        children: "*"
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ _jsx(ReactSearchAutocomplete, {
                                                                                items: supplierInfos,
                                                                                placeholder: "ค้นหา",
                                                                                onSelect: function(item) {
                                                                                    setValues(_object_spread_props(_object_spread({}, values), {
                                                                                        dim_supplier_information_id: item.id,
                                                                                        dim_mst_payment_type_id: item.dim_mst_payment_type_id ? item.dim_mst_payment_type_id : values.dim_mst_payment_type_id,
                                                                                        dim_mst_price_category_id: item.dim_mst_price_category_id ? item.dim_mst_price_category_id : values.dim_mst_price_category_id
                                                                                    }));
                                                                                    setPdata(function(prev) {
                                                                                        return {
                                                                                            id: item.id,
                                                                                            dimGroupOfSupplierCode: item.dimGroupOfSupplier ? item.dimGroupOfSupplier.code : "-",
                                                                                            full_supplier_name: item.full_supplier_name,
                                                                                            initials: item.initials,
                                                                                            company_branch_code: item.company_branch_code,
                                                                                            company_branch_name: item.company_branch_name,
                                                                                            full_supplier_address_name: item.full_supplier_address_name,
                                                                                            company_phone_number: item.company_phone_number
                                                                                        };
                                                                                    });
                                                                                },
                                                                                onClear: function() {
                                                                                    setFieldValue("dim_supplier_information_id", "");
                                                                                    setPdata(function(prev) {
                                                                                        return {
                                                                                            id: "",
                                                                                            dimGroupOfSupplierCode: "",
                                                                                            full_supplier_name: "-",
                                                                                            initials: "-",
                                                                                            company_branch_code: "",
                                                                                            company_branch_name: "",
                                                                                            full_supplier_address_name: "-",
                                                                                            company_phone_number: "-"
                                                                                        };
                                                                                    });
                                                                                },
                                                                                autoFocus: true,
                                                                                formatResult: formatResult,
                                                                                fuseOptions: {
                                                                                    keys: [
                                                                                        "dimGroupOfSupplierCode",
                                                                                        "full_supplier_name",
                                                                                        "initials"
                                                                                    ]
                                                                                },
                                                                                resultStringKeyName: "full_supplier_name",
                                                                                styling: {
                                                                                    height: "54px",
                                                                                    borderRadius: "10px",
                                                                                    boxShadow: "none",
                                                                                    zIndex: 10,
                                                                                    border: !values.dim_supplier_information_id ? "1px solid #dc3545" : "1px solid rgb(223, 225, 229)"
                                                                                },
                                                                                showIcon: false,
                                                                                className: "scrollSearchAutocomplete"
                                                                            })
                                                                        ]
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ _jsx("div", {
                                                                    className: "col-2",
                                                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                        className: "mb-2 form-st-3 pb-1",
                                                                        children: [
                                                                            /*#__PURE__*/ _jsxs(Form.Label, {
                                                                                className: "mb-1",
                                                                                children: [
                                                                                    "ประเภทราคา",
                                                                                    " ",
                                                                                    /*#__PURE__*/ _jsx("span", {
                                                                                        className: "text-[#FF0000]",
                                                                                        children: "*"
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ _jsx(Select, {
                                                                                as: "select",
                                                                                name: "dim_mst_price_category_id",
                                                                                onChange: function(e) {
                                                                                    setFieldValue("dim_mst_price_category_id", e.value);
                                                                                },
                                                                                className: "w-100 select-st-1 ".concat(values.dim_mst_price_category_id ? "" : !!errors.dim_mst_price_category_id ? "is-invalid" : ""),
                                                                                options: optionsMstPriceCategory,
                                                                                placeholder: "เลือกประเภทราคา",
                                                                                value: optionsMstPriceCategory.filter(function(item) {
                                                                                    return item.value === values.dim_mst_price_category_id;
                                                                                })
                                                                            })
                                                                        ]
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ _jsx("div", {
                                                                    className: "col-2",
                                                                    children: /*#__PURE__*/ _jsx(Form.Group, {
                                                                        className: "   mt-[12px]",
                                                                        children: /*#__PURE__*/ _jsx(LocalizationProvider, {
                                                                            dateAdapter: AdapterDayjs,
                                                                            className: "h-[40px] ",
                                                                            children: /*#__PURE__*/ _jsx(DatePicker, {
                                                                                format: "DD/MM/YYYY",
                                                                                slotProps: {
                                                                                    textField: {
                                                                                        InputLabelProps: {
                                                                                            shrink: true,
                                                                                            sx: {
                                                                                                "&::after": {
                                                                                                    content: '" *"',
                                                                                                    color: "#FF0000",
                                                                                                    paddingRight: "5px",
                                                                                                    background: "white"
                                                                                                }
                                                                                            }
                                                                                        },
                                                                                        error: !!errors.doc_issue_date
                                                                                    }
                                                                                },
                                                                                label: "วันที่ออก",
                                                                                className: "h-[40px] w-full ",
                                                                                sx: {
                                                                                    ".MuiInputBase-formControl": {
                                                                                        height: "53px",
                                                                                        borderRadius: "8px"
                                                                                    },
                                                                                    ".MuiFormLabel-root": {
                                                                                        fontFamily: "Sarabun"
                                                                                    },
                                                                                    ".MuiOutlinedInput-notchedOutline": {
                                                                                        border: "1px solid rgba(76, 78, 100, 0.22)"
                                                                                    }
                                                                                },
                                                                                name: "doc_issue_date",
                                                                                value: values.doc_issue_date ? dayjs(values.doc_issue_date) : null,
                                                                                onChange: function(date) {
                                                                                    var formattedDate = dayjs(date).isValid() ? dayjs(date).format("YYYY-MM-DD") : null;
                                                                                    setFieldValue("doc_issue_date", formattedDate);
                                                                                }
                                                                            })
                                                                        })
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ _jsx("div", {
                                                                    className: "col-2",
                                                                    children: /*#__PURE__*/ _jsx(Form.Group, {
                                                                        className: "   mt-[12px]",
                                                                        children: /*#__PURE__*/ _jsx(LocalizationProvider, {
                                                                            dateAdapter: AdapterDayjs,
                                                                            className: "h-[40px] ",
                                                                            children: /*#__PURE__*/ _jsx(DatePicker, {
                                                                                format: "DD/MM/YYYY",
                                                                                slotProps: {
                                                                                    textField: {
                                                                                        InputLabelProps: {
                                                                                            shrink: true,
                                                                                            sx: {
                                                                                                "&::after": {
                                                                                                    content: '" *"',
                                                                                                    color: "#FF0000",
                                                                                                    paddingRight: "5px",
                                                                                                    background: "white"
                                                                                                }
                                                                                            }
                                                                                        },
                                                                                        error: !!errors.doc_due_date
                                                                                    }
                                                                                },
                                                                                label: "วันที่ครบกำหนด",
                                                                                className: "h-[40px] w-full ",
                                                                                sx: {
                                                                                    ".MuiInputBase-formControl": {
                                                                                        height: "53px",
                                                                                        borderRadius: "8px"
                                                                                    },
                                                                                    ".MuiFormLabel-root": {
                                                                                        fontFamily: "Sarabun"
                                                                                    },
                                                                                    ".MuiOutlinedInput-notchedOutline": {
                                                                                        border: "1px solid rgba(76, 78, 100, 0.22)"
                                                                                    }
                                                                                },
                                                                                name: "doc_due_date",
                                                                                value: values.doc_due_date ? dayjs(values.doc_due_date) : null,
                                                                                onChange: function(date) {
                                                                                    var formattedDate = dayjs(date).isValid() ? dayjs(date).format("YYYY-MM-DD") : null;
                                                                                    setFieldValue("doc_due_date", formattedDate);
                                                                                }
                                                                            })
                                                                        })
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ _jsx("div", {
                                                                    className: "col-2",
                                                                    children: /*#__PURE__*/ _jsxs("div", {
                                                                        className: "pb-4 pt-7",
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx("div", {
                                                                                className: "fw-bold fs-18 mb-2",
                                                                                children: "บริษัท"
                                                                            }),
                                                                            /*#__PURE__*/ _jsx("div", {
                                                                                children: pdata.full_supplier_name
                                                                            })
                                                                        ]
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ _jsx("div", {
                                                                    className: "col-2",
                                                                    children: /*#__PURE__*/ _jsxs("div", {
                                                                        className: "pb-4 pt-7",
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx("div", {
                                                                                className: "fw-bold fs-18 mb-2",
                                                                                children: "ที่อยู่"
                                                                            }),
                                                                            /*#__PURE__*/ _jsx("div", {
                                                                                children: /*#__PURE__*/ _jsx("div", {
                                                                                    children: pdata.full_supplier_address_name
                                                                                })
                                                                            })
                                                                        ]
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ _jsx("div", {
                                                                    className: "col-3",
                                                                    children: /*#__PURE__*/ _jsxs("div", {
                                                                        className: "pb-4 pt-7",
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx("div", {
                                                                                className: "fw-bold fs-18 mb-2",
                                                                                children: "เบอร์โทร"
                                                                            }),
                                                                            /*#__PURE__*/ _jsx("div", {
                                                                                children: /*#__PURE__*/ _jsx("div", {
                                                                                    children: pdata.company_phone_number
                                                                                })
                                                                            })
                                                                        ]
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ _jsx("div", {
                                                                    className: "col-3",
                                                                    children: /*#__PURE__*/ _jsxs("div", {
                                                                        className: "pb-4 pt-7",
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx("div", {
                                                                                className: "fw-bold fs-18 mb-2",
                                                                                children: "ชื่อย่อ"
                                                                            }),
                                                                            /*#__PURE__*/ _jsx("div", {
                                                                                children: /*#__PURE__*/ _jsx("div", {
                                                                                    children: pdata.initials
                                                                                })
                                                                            })
                                                                        ]
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            })
                                        })
                                    })
                                })
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "mb-4",
                                children: [
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "mb-3 pagezoom",
                                        children: /*#__PURE__*/ _jsx("button", {
                                            type: "button",
                                            className: "btn btn-st-3 me-3",
                                            style: tab != 1 ? {
                                                background: "transparent",
                                                border: 0,
                                                color: "#9C9C9C"
                                            } : {},
                                            children: "ข้อมูลสินค้า"
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(ProductData, {
                                        values: values,
                                        setFieldValue: setFieldValue,
                                        productRow: productRow,
                                        setProductRow: setProductRow,
                                        optionsMstDiscountType: optionsMstDiscountType,
                                        optionsMstVat: optionsMstVat,
                                        optionsNewItemExpenseCol: optionsNewItemExpenseCol,
                                        columnsort: columnsort,
                                        setColumnsort: setColumnsort,
                                        setFormdata: setFormdata,
                                        setPdata: setPdata,
                                        formdisabled: formdisabled,
                                        caseController: caseController,
                                        optionExpense: optionsMstAddCost,
                                        optionExpenseUnit: optionsMstAddCostUnit,
                                        optionTax: optionsMstVat,
                                        optionWithholdingTax: optionsMstWithholdingTax,
                                        sumproductPrice: sumproductPrice,
                                        setSumproductPrice: setSumproductPrice,
                                        sumproductNoVat: sumproductNoVat,
                                        setSumproductNoVat: setSumproductNoVat,
                                        sumproductZeroVat: sumproductZeroVat,
                                        setSumproductZeroVat: setSumproductZeroVat,
                                        sumproductSevenVat: sumproductSevenVat,
                                        setSumproductSevenVat: setSumproductSevenVat,
                                        sumproductBeforeVat: sumproductBeforeVat,
                                        setSumproductBeforeVat: setSumproductBeforeVat
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx("fieldset", {
                                disabled: formdisabled,
                                children: /*#__PURE__*/ _jsxs("div", {
                                    className: "card card-st-3 mb-4 pagezoom",
                                    style: {
                                        minWidth: "1000px"
                                    },
                                    children: [
                                        /*#__PURE__*/ _jsxs("div", {
                                            className: "card-body px-xl-3",
                                            children: [
                                                /*#__PURE__*/ _jsxs("div", {
                                                    className: "row",
                                                    children: [
                                                        /*#__PURE__*/ _jsx("div", {
                                                            className: "col",
                                                            children: /*#__PURE__*/ _jsx("div", {
                                                                className: "fs-20 fw-bold",
                                                                children: "สรุปข้อมูล"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ _jsx("div", {
                                                            className: "col-auto",
                                                            children: /*#__PURE__*/ _jsx("table", {
                                                                className: "table table-d1 table-borderless",
                                                                children: /*#__PURE__*/ _jsxs("tbody", {
                                                                    children: [
                                                                        /*#__PURE__*/ _jsxs("tr", {
                                                                            children: [
                                                                                /*#__PURE__*/ _jsx("td", {
                                                                                    className: "text-end",
                                                                                    children: "มูลค่าสินค้าก่อนส่วนลด"
                                                                                }),
                                                                                /*#__PURE__*/ _jsx("td", {
                                                                                    children: /*#__PURE__*/ _jsx("div", {
                                                                                        className: "fw-bold text-end",
                                                                                        style: {
                                                                                            color: "#636578"
                                                                                        },
                                                                                        children: NumberFormat(sumproductPrice, 2)
                                                                                    })
                                                                                }),
                                                                                /*#__PURE__*/ _jsx("td", {
                                                                                    children: "บาท"
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ _jsxs("tr", {
                                                                            children: [
                                                                                /*#__PURE__*/ _jsx("td", {
                                                                                    children: /*#__PURE__*/ _jsxs("div", {
                                                                                        className: "d-flex align-items-center",
                                                                                        children: [
                                                                                            /*#__PURE__*/ _jsx("div", {
                                                                                                className: "me-2",
                                                                                                children: "ส่วนลด "
                                                                                            }),
                                                                                            /*#__PURE__*/ _jsxs("div", {
                                                                                                className: "d-flex align-items-center",
                                                                                                children: [
                                                                                                    /*#__PURE__*/ _jsx(Form.Control, {
                                                                                                        type: "number",
                                                                                                        name: "discount_value",
                                                                                                        className: "form-control",
                                                                                                        placeholder: "",
                                                                                                        value: values.discount_value,
                                                                                                        onChange: function(e) {
                                                                                                            setValues(_object_spread_props(_object_spread({}, values), {
                                                                                                                discount_value: NumberFormatFloat(e.target.value, 4)
                                                                                                            }));
                                                                                                        },
                                                                                                        isInvalid: !!errors.discount_value,
                                                                                                        style: {
                                                                                                            borderRight: 0,
                                                                                                            borderTopRightRadius: 0,
                                                                                                            borderBottomRightRadius: 0,
                                                                                                            width: "80px"
                                                                                                        }
                                                                                                    }),
                                                                                                    /*#__PURE__*/ _jsx(Select, {
                                                                                                        as: "select",
                                                                                                        name: "dim_mst_discount_type_id",
                                                                                                        onChange: function(e) {
                                                                                                            setFieldValue("dim_mst_discount_type_id", e.value);
                                                                                                        },
                                                                                                        className: "w-100  select-st-2",
                                                                                                        options: optionsMstDiscountType,
                                                                                                        placeholder: "",
                                                                                                        value: optionsMstDiscountType.filter(function(item) {
                                                                                                            return item.value === values.dim_mst_discount_type_id;
                                                                                                        }),
                                                                                                        style: {
                                                                                                            borderLeft: 0,
                                                                                                            borderTopLeftRadius: 0,
                                                                                                            borderBottomLeftRadius: 0,
                                                                                                            width: "80px"
                                                                                                        }
                                                                                                    })
                                                                                                ]
                                                                                            })
                                                                                        ]
                                                                                    })
                                                                                }),
                                                                                /*#__PURE__*/ _jsx("td", {
                                                                                    children: /*#__PURE__*/ _jsx(DiscountInput, {
                                                                                        sumproductPrice: sumproductPrice
                                                                                    })
                                                                                }),
                                                                                /*#__PURE__*/ _jsx("td", {
                                                                                    children: "บาท"
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ _jsxs("tr", {
                                                                            children: [
                                                                                /*#__PURE__*/ _jsx("td", {
                                                                                    className: "text-end",
                                                                                    children: "มูลค่าสินค้าหลังหักส่วนลด"
                                                                                }),
                                                                                /*#__PURE__*/ _jsx("td", {
                                                                                    children: /*#__PURE__*/ _jsx("div", {
                                                                                        className: "fw-bold text-end",
                                                                                        style: {
                                                                                            color: "#636578"
                                                                                        },
                                                                                        children: values.dim_mst_discount_type_id === 1 ? NumberFormat(sumproductPrice * ((100 - values.discount_value) * 0.01), 2) : NumberFormat(sumproductPrice - values.discount_value, 2)
                                                                                    })
                                                                                }),
                                                                                /*#__PURE__*/ _jsx("td", {
                                                                                    children: "บาท"
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        }),
                                                        /*#__PURE__*/ _jsx("div", {
                                                            className: "col-auto",
                                                            children: /*#__PURE__*/ _jsx("table", {
                                                                className: "table table-d1 table-borderless",
                                                                children: /*#__PURE__*/ _jsxs("tbody", {
                                                                    children: [
                                                                        /*#__PURE__*/ _jsxs("tr", {
                                                                            children: [
                                                                                /*#__PURE__*/ _jsx("td", {
                                                                                    className: "text-end",
                                                                                    children: "มูลค่าสินค้ายกเว้นภาษี"
                                                                                }),
                                                                                /*#__PURE__*/ _jsx("td", {
                                                                                    children: /*#__PURE__*/ _jsx("div", {
                                                                                        className: "fw-bold text-end",
                                                                                        style: {
                                                                                            color: "#636578"
                                                                                        },
                                                                                        children: NumberFormat(WDA(sumproductNoVat, sumproductBeforeVat, getDiscountValue(values.dim_mst_discount_type_id, sumproductPrice, values.discount_value), false), 2)
                                                                                    })
                                                                                }),
                                                                                /*#__PURE__*/ _jsx("td", {
                                                                                    children: "บาท"
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ _jsxs("tr", {
                                                                            children: [
                                                                                /*#__PURE__*/ _jsx("td", {
                                                                                    className: "text-end",
                                                                                    children: "มูลค่าสินค้าภาษี 0 %"
                                                                                }),
                                                                                /*#__PURE__*/ _jsx("td", {
                                                                                    children: /*#__PURE__*/ _jsx("div", {
                                                                                        className: "fw-bold text-end",
                                                                                        style: {
                                                                                            color: "#636578"
                                                                                        },
                                                                                        children: NumberFormat(WDA(sumproductZeroVat, sumproductBeforeVat, getDiscountValue(values.dim_mst_discount_type_id, sumproductPrice, values.discount_value), false), 2)
                                                                                    })
                                                                                }),
                                                                                /*#__PURE__*/ _jsx("td", {
                                                                                    children: "บาท"
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ _jsxs("tr", {
                                                                            children: [
                                                                                /*#__PURE__*/ _jsx("td", {
                                                                                    className: "text-end",
                                                                                    children: "มูลค่าสินค้าภาษี 7 %"
                                                                                }),
                                                                                /*#__PURE__*/ _jsx("td", {
                                                                                    children: /*#__PURE__*/ _jsx("div", {
                                                                                        className: "fw-bold text-end",
                                                                                        style: {
                                                                                            color: "#636578"
                                                                                        },
                                                                                        children: NumberFormat(WDA(sumproductSevenVat, sumproductBeforeVat, getDiscountValue(values.dim_mst_discount_type_id, sumproductPrice, values.discount_value), true), 2)
                                                                                    })
                                                                                }),
                                                                                /*#__PURE__*/ _jsx("td", {
                                                                                    children: "บาท"
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ _jsxs("tr", {
                                                                            children: [
                                                                                /*#__PURE__*/ _jsx("td", {
                                                                                    className: "text-end",
                                                                                    children: "ภาษีมูลค่าเพิ่ม"
                                                                                }),
                                                                                /*#__PURE__*/ _jsx("td", {
                                                                                    children: /*#__PURE__*/ _jsx("div", {
                                                                                        className: "fw-bold text-end",
                                                                                        style: {
                                                                                            color: "#636578"
                                                                                        },
                                                                                        children: NumberFormat(WDA(sumproductSevenVat, sumproductBeforeVat, getDiscountValue(values.dim_mst_discount_type_id, sumproductPrice, values.discount_value), true) * 0.07, 2)
                                                                                    })
                                                                                }),
                                                                                /*#__PURE__*/ _jsx("td", {
                                                                                    children: "บาท"
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        }),
                                                        /*#__PURE__*/ _jsxs("div", {
                                                            className: "col-auto",
                                                            children: [
                                                                /*#__PURE__*/ _jsx("div", {
                                                                    className: "mb-3 mt-2",
                                                                    children: " มูลค่าสุทธิรวม"
                                                                }),
                                                                /*#__PURE__*/ _jsxs("div", {
                                                                    className: "text-white fs-24",
                                                                    style: {
                                                                        background: "#FF6B00",
                                                                        padding: "12px 20px",
                                                                        borderRadius: "8px"
                                                                    },
                                                                    children: [
                                                                        /*#__PURE__*/ _jsx("span", {
                                                                            children: values.dim_mst_discount_type_id === 1 ? NumberFormat(sumproductPrice * ((100 - values.discount_value) * 0.01), 2) : NumberFormat(sumproductPrice - values.discount_value, 2)
                                                                        }),
                                                                        /*#__PURE__*/ _jsx("span", {
                                                                            className: "fs-14 ms-2",
                                                                            children: "บาท"
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ _jsx("hr", {
                                                    className: "my-4",
                                                    style: {
                                                        opacity: 0.1
                                                    }
                                                }),
                                                /*#__PURE__*/ _jsx("div", {
                                                    className: "row",
                                                    children: /*#__PURE__*/ _jsx("div", {
                                                        className: "col-6",
                                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                            className: "mb-3",
                                                            controlId: "exampleForm.ControlTextarea1",
                                                            children: [
                                                                /*#__PURE__*/ _jsx(Form.Label, {
                                                                    className: "fw-bold fs-18",
                                                                    children: "หมายเหตุ"
                                                                }),
                                                                /*#__PURE__*/ _jsx(Form.Control, {
                                                                    as: "textarea",
                                                                    rows: 3,
                                                                    name: "remark",
                                                                    value: values.remark,
                                                                    onChange: handleChange
                                                                })
                                                            ]
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ _jsx("hr", {
                                                    className: "my-4",
                                                    style: {
                                                        opacity: 0.1
                                                    }
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "py-5"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "card pagezoom card-st-3  mb-4 fixed bottom-0 w-[calc(100%-110px)] drop-shadow",
                                style: {
                                    minWidth: "1000px"
                                },
                                children: /*#__PURE__*/ _jsxs("div", {
                                    className: "card-body px-xl-3 d-flex ",
                                    children: [
                                        isReadyToPrint(formdisabled, values.dimMstExpenseStatus ? values.dimMstExpenseStatus.id : 0) && /*#__PURE__*/ _jsxs(_Fragment, {
                                            children: [
                                                /*#__PURE__*/ _jsx("div", {
                                                    style: {
                                                        display: "none"
                                                    }
                                                }),
                                                /*#__PURE__*/ _jsxs(Button, {
                                                    type: "button",
                                                    className: "btn-st-8 fs-14 border-0 px-3 me-3",
                                                    onClick: handlePrint,
                                                    disabled: true,
                                                    children: [
                                                        /*#__PURE__*/ _jsx("i", {
                                                            className: "iprinter"
                                                        }),
                                                        "พิมพ์เอกสาร"
                                                    ]
                                                }),
                                                /*#__PURE__*/ _jsxs(Dropdown, {
                                                    children: [
                                                        /*#__PURE__*/ _jsx(Dropdown.Toggle, {
                                                            className: "btn btn-st-8 fs-14  px-4",
                                                            id: "dropdown-basic",
                                                            style: {
                                                                backgroundColor: "#565DFF",
                                                                borderColor: "#565DFF",
                                                                height: "40px"
                                                            },
                                                            children: "ตัวเลือก"
                                                        }),
                                                        /*#__PURE__*/ _jsxs(Dropdown.Menu, {
                                                            className: "p-0 border-0",
                                                            children: [
                                                                /*#__PURE__*/ _jsx(Button, {
                                                                    type: "button",
                                                                    className: "btn-st-6  w-100 ",
                                                                    children: "คัดลอกเอกสาร"
                                                                }),
                                                                /*#__PURE__*/ _jsx(Button, {
                                                                    type: "button",
                                                                    className: "btn-st-6  w-100",
                                                                    children: "ยกเลิกเอกสาร"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsx(Button, {
                                            type: "button",
                                            onClick: function(e) {
                                                navigate("/goods-receipt");
                                            },
                                            className: "btn-st-6 me-3 btn ms-auto",
                                            children: "ย้อนกลับ"
                                        }),
                                        values.dim_new_gr_id && /*#__PURE__*/ _jsx(Button, {
                                            type: "button",
                                            onClick: function() {
                                                setFormdisabled(false);
                                            },
                                            className: "btn-st-3 me-3 lock-btn",
                                            disabled: true,
                                            children: "แก้ไข"
                                        }),
                                        !values.dim_new_gr_id && /*#__PURE__*/ _jsx(Button, {
                                            type: "submit",
                                            className: "bg-[#565DFF] text-white  btn w-[100px] ",
                                            onClick: function(e) {
                                                setFieldValue("dim_mst_expense_status_id", 2);
                                                var isInValid = grVerifyCases(productRow, sumProductBalanceQuantity);
                                                if (isInValid.productQtyNotMatch || isInValid.inputInvalid) {
                                                    e.preventDefault();
                                                    e.stopPropagation();
                                                    setAlert(function(prev) {
                                                        return _object_spread_props(_object_spread({}, prev), {
                                                            productQtyNotMatch: isInValid.productQtyNotMatch,
                                                            InputInvalid: isInValid.inputInvalid
                                                        });
                                                    });
                                                    setModalVerifyInformation(function(prev) {
                                                        return _object_spread_props(_object_spread({}, prev), {
                                                            open: true
                                                        });
                                                    });
                                                }
                                            },
                                            children: "บันทึก"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "py-[60px]"
                            })
                        ]
                    });
                }
            }),
            /*#__PURE__*/ _jsxs(ModalAllder, {
                modal: modalSuccess,
                setModal: setModalSuccess,
                htitle: "แจ้งเตือน",
                hbtn: false,
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "text-center mb-4 mt-4 pt-2 pb-2",
                        children: /*#__PURE__*/ _jsx("img", {
                            className: "mx-auto",
                            src: "/images/check.png"
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "text-center fw-bold",
                        style: {
                            fontSize: "22px",
                            color: "#2F4858"
                        },
                        children: "บันทึกสำเร็จ"
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs(ModalAllder, {
                modal: modalSaveSuccess,
                setModal: setModalSaveSuccess,
                htitle: "แจ้งเตือน",
                hbtn: false,
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "text-center mb-4 mt-4 pt-2 pb-2",
                        children: /*#__PURE__*/ _jsx("img", {
                            className: "mx-auto",
                            src: "/images/check.png"
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "text-center fw-bold",
                        style: {
                            fontSize: "22px",
                            color: "#2F4858"
                        },
                        children: "บันทึกสำเร็จ"
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs(ModalAllder, {
                modal: modalSaveSuccess,
                setModal: setModalSaveSuccess,
                htitle: "แจ้งเตือน",
                hbtn: false,
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "text-center mb-4 mt-4 pt-2 pb-2",
                        children: /*#__PURE__*/ _jsx("img", {
                            className: "mx-auto",
                            src: "/images/check.png"
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "text-center fw-bold",
                        style: {
                            fontSize: "22px",
                            color: "#2F4858"
                        },
                        children: "บันทึกสำเร็จ"
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs(ModalAllder, {
                modal: modalApproveSuccess,
                setModal: setModalApproveSuccess,
                htitle: "แจ้งเตือน",
                hbtn: false,
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "text-center mb-4 mt-4 pt-2 pb-2",
                        children: /*#__PURE__*/ _jsx("img", {
                            className: "mx-auto",
                            src: "/images/check.png"
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "text-center mb-3",
                        style: {
                            fontSize: "22px",
                            color: "rgba(76, 78, 100, 0.87)"
                        },
                        children: "คุณอนุมัติใบขอซื้อ"
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "text-center  mb-3",
                        style: {
                            fontSize: "22px",
                            color: "#565DFF"
                        },
                        children: "เลขที่ PR-2410000001"
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "text-center  mb-2 fw-bold",
                        style: {
                            fontSize: "22px",
                            color: "#636578"
                        },
                        children: "สำเร็จ"
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs(ModalAllder, {
                modal: modalAlert,
                setModal: setModalAlert,
                htitle: "แจ้งเตือน",
                hbtn: false,
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: "text-center pt-4",
                        style: {
                            fontSize: "22px",
                            color: "#2F4858"
                        },
                        children: [
                            "กรุณาเพิ่มรายการรับสินค้า ",
                            /*#__PURE__*/ _jsx("br", {}),
                            " อย่างน้อย 1 รายการ"
                        ]
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "d-flex align-items-center pb-4 pt-5 ",
                        children: /*#__PURE__*/ _jsx(Button, {
                            type: "button",
                            className: "btn-st-3 mx-auto",
                            onClick: function() {
                                return setModalAlert(function(prev) {
                                    return _object_spread_props(_object_spread({}, prev), {
                                        open: false
                                    });
                                });
                            },
                            children: "ยืนยัน"
                        })
                    })
                ]
            })
        ]
    });
}
function ProductData(_param) {
    var values = _param.values, setFieldValue = _param.setFieldValue, optionsMstDiscountType = _param.optionsMstDiscountType, optionsMstVat = _param.optionsMstVat, optionsNewItemExpenseCol = _param.optionsNewItemExpenseCol, productRow = _param.productRow, setProductRow = _param.setProductRow, columnsort = _param.columnsort, setColumnsort = _param.setColumnsort, setFormdata = _param.setFormdata, setPdata = _param.setPdata, sumproductPrice = _param.sumproductPrice, setSumproductPrice = _param.setSumproductPrice, sumproductNoVat = _param.sumproductNoVat, setSumproductNoVat = _param.setSumproductNoVat, sumproductZeroVat = _param.sumproductZeroVat, setSumproductZeroVat = _param.setSumproductZeroVat, sumproductSevenVat = _param.sumproductSevenVat, setSumproductSevenVat = _param.setSumproductSevenVat, sumproductBeforeVat = _param.sumproductBeforeVat, setSumproductBeforeVat = _param.setSumproductBeforeVat, formdisabled = _param.formdisabled, caseController = _param.caseController, optionExpense = _param.optionExpense, optionExpenseUnit = _param.optionExpenseUnit, optionWithholdingTax = _param.optionWithholdingTax, optionTax = _param.optionTax, props = _object_without_properties(_param, [
        "values",
        "setFieldValue",
        "optionsMstDiscountType",
        "optionsMstVat",
        "optionsNewItemExpenseCol",
        "productRow",
        "setProductRow",
        "columnsort",
        "setColumnsort",
        "setFormdata",
        "setPdata",
        "sumproductPrice",
        "setSumproductPrice",
        "sumproductNoVat",
        "setSumproductNoVat",
        "sumproductZeroVat",
        "setSumproductZeroVat",
        "sumproductSevenVat",
        "setSumproductSevenVat",
        "sumproductBeforeVat",
        "setSumproductBeforeVat",
        "formdisabled",
        "caseController",
        "optionExpense",
        "optionExpenseUnit",
        "optionWithholdingTax",
        "optionTax"
    ]);
    var addProductRow = function(num) {
        for(var i = 0; i < num; i++){
            setProductRow(function(row) {
                return _to_consumable_array(row).concat([
                    {
                        rowID: nanoid(),
                        id: "",
                        unit: "",
                        productQty: "",
                        discount: 0,
                        discountPercent: 0,
                        discountType: 1,
                        dim_mst_vat_id: 1,
                        productPrice: 0,
                        vat: 0,
                        tax: "",
                        price_before_tax: "",
                        withholding_tax: "",
                        note: "",
                        is_checked: false,
                        edit: false
                    }
                ]);
            });
        }
    };
    useEffect(function() {
        if (productRow.length <= 0) {
            addProductRow(4);
        }
    }, []);
    var _useState = _sliced_to_array(useState(0), 2), rowCount = _useState[0], setRowCount = _useState[1];
    var _useState1 = _sliced_to_array(useState({
        open: false,
        x: 0,
        y: 0,
        width: 530,
        height: 570,
        pin: false,
        mode: "normal",
        modalname: "gr-product-display"
    }), 2), modalDisplayColumn = _useState1[0], setModalDisplayColumn = _useState1[1];
    var _useState2 = _sliced_to_array(useState({
        barcode: false,
        supplierCode: false
    }), 2), columdisplay = _useState2[0], setColumDisplay = _useState2[1];
    useEffect(function() {
        var idisplay = localStorage.getItem("columGRdisplay");
        if (idisplay) {
            setColumDisplay(JSON.parse(idisplay));
        }
    }, []);
    var items = useMemo(function() {
        return productRow === null || productRow === void 0 ? void 0 : productRow.map(function(param) {
            var rowID = param.rowID;
            return rowID;
        });
    }, [
        productRow
    ]);
    var sensors = useSensors(useSensor(MouseSensor, {}), useSensor(TouchSensor, {}), useSensor(KeyboardSensor, {}));
    var _useState3 = _sliced_to_array(useState(false), 2), customSort = _useState3[0], setCustomSort = _useState3[1];
    var _useState4 = _sliced_to_array(useState(), 2), activeId = _useState4[0], setActiveId = _useState4[1];
    function handleDragStart(event) {
        setActiveId(event.active.id);
        var active = event.active, over = event.over;
    // console.log(event)
    }
    function handleDragEnd(event) {
        var active = event.active, over = event.over;
        if (active.id !== over.id) {
            setProductRow(function(productRow) {
                var oldIndex = items.indexOf(active.id);
                var newIndex = items.indexOf(over.id);
                return arrayMove(productRow, oldIndex, newIndex);
            });
        }
        setActiveId(null);
    }
    function handleDragCancel() {
        setActiveId(null);
    }
    var selectedRow = useMemo(function() {
        if (!activeId) {
            return null;
        }
        var row = productRow.filter(function(prev) {
            return prev.rowID == activeId;
        });
        return row;
    }, [
        activeId
    ]);
    var _useState5 = _sliced_to_array(useState(0), 2), sumproductQty = _useState5[0], setSumproductQty = _useState5[1];
    var _useState6 = _sliced_to_array(useState(0), 2), sumUms = _useState6[0], setSumUms = _useState6[1];
    var _useState7 = _sliced_to_array(useState(0), 2), sumProductVat = _useState7[0], setSumProductVat = _useState7[1];
    var sumQty = function(productRow) {
        var qty = 0;
        var price = 0;
        var priceBeforeVat = 0;
        var priceNoVat = 0;
        var priceZeroVat = 0;
        var priceSevenVat = 0;
        var priceVat = 0;
        var ordered = 0;
        var ums = 0;
        productRow.forEach(function(pd) {
            var productQty = parseFloat(pd.productQty);
            var productPrice = parseFloat(pd.productPrice);
            var productRatioUnit = parseInt(pd.productRatioUnit);
            var productOrdered = parseInt(pd.productOrdered);
            var hasValidQty = productQty > 0;
            var hasValidPrice = productPrice > 0;
            // Calculate price and priceBeforeVat if both quantity and price are valid
            if (hasValidQty) {
                qty += productQty;
                ums += productRatioUnit * productQty;
                ordered += productOrdered;
            }
            if (hasValidQty && hasValidPrice) {
                price += calPriceByMstCategoryPriceTax(pd, values.dim_mst_price_category_id, false);
                priceBeforeVat += calPriceByMstCategoryPriceTax(pd, values.dim_mst_price_category_id, true);
                // Calculate prices based on VAT type
                switch(parseInt(pd.dim_mst_vat_id)){
                    case 1:
                        priceNoVat += calPriceByMstCategoryPriceTax(pd, values.dim_mst_price_category_id, true);
                        break;
                    case 2:
                        priceZeroVat += calPriceByMstCategoryPriceTax(pd, values.dim_mst_price_category_id, true);
                        break;
                    case 3:
                        priceSevenVat += calPriceByMstCategoryPriceTax(pd, values.dim_mst_price_category_id, true);
                        break;
                    default:
                        console.log(pd.dim_mst_vat_id);
                        break;
                }
                priceVat += calPriceByMstCategoryPriceTax(pd, values.dim_mst_price_category_id, false) - calPriceByMstCategoryPriceTax(pd, values.dim_mst_price_category_id, true);
            }
        });
        setSumproductPrice(price);
        setSumproductBeforeVat(priceBeforeVat);
        setSumproductNoVat(priceNoVat);
        setSumproductZeroVat(priceZeroVat);
        setSumproductSevenVat(priceSevenVat);
        setSumProductVat(priceVat);
        setSumproductQty(qty);
    };
    useEffect(function() {
        if (values.dim_mst_price_category_id == 3) {
            setProductRowVatByMstCategoryPrice(values.dim_mst_price_category_id, setProductRow);
        }
    }, [
        values.dim_mst_price_category_id
    ]);
    useEffect(function() {
        setRowCount(productRow.length);
        sumQty(productRow);
    // const product = productRow.filter((prev) => prev.productCode !== "");
    // setFieldValue("products", productRow);
    // setProductRow(product);
    }, [
        productRow,
        values.dim_mst_price_category_id
    ]);
    var checkLength = productRow.filter(function(row) {
        return row.is_checked === true;
    });
    // productRow
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(ModalAllder, {
                modal: modalDisplayColumn,
                setModal: setModalDisplayColumn,
                htitle: "ตัวเลือกการแสดงผล",
                hbtn: true,
                children: /*#__PURE__*/ _jsx(ProductTableDisplay, {
                    columdisplay: columdisplay,
                    columdisplayName: "columGRdisplay",
                    setModalDisplayColumn: setModalDisplayColumn,
                    setColumDisplay: setColumDisplay
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "pagezoom",
                children: checkLength.length > 0 ? /*#__PURE__*/ _jsxs("div", {
                    className: "mb-3",
                    children: [
                        /*#__PURE__*/ _jsx("button", {
                            className: "btn btn-st-x1 me-2",
                            onClick: function() {
                                var checkLenght = productRow.filter(function(item) {
                                    return item.is_checked === true;
                                }).length;
                                setProductRow(function(productRow) {
                                    return productRow.filter(function(item) {
                                        return item.is_checked !== true;
                                    });
                                });
                                addProductRow(checkLenght);
                            },
                            children: "ลบที่เลือก"
                        }),
                        /*#__PURE__*/ _jsx("button", {
                            className: "btn btn-st-x1 me-2",
                            onClick: function() {
                                setProductRow(function(prev) {
                                    return prev.map(function(el) {
                                        return _object_spread_props(_object_spread({}, el), {
                                            is_checked: false
                                        });
                                    });
                                });
                            },
                            children: "ยกเลิก"
                        })
                    ]
                }) : /*#__PURE__*/ _jsx("div", {
                    className: "mb-3 flex",
                    children: /*#__PURE__*/ _jsx("button", {
                        type: "button",
                        className: "btn btn-st-x1 me-2",
                        onClick: function() {
                            setModalDisplayColumn(function(prev) {
                                return _object_spread_props(_object_spread({}, prev), {
                                    open: true
                                });
                            });
                        },
                        disabled: true,
                        children: "ตัวเลือกแสดงผล"
                    })
                })
            }),
            /*#__PURE__*/ _jsxs("fieldset", {
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "pagezoom",
                        style: {
                            overflowX: "auto",
                            maxWidth: "100%",
                            overflowY: "hidden",
                            paddingBottom: "20px"
                        },
                        children: /*#__PURE__*/ _jsx(DndContext, {
                            sensors: sensors,
                            collisionDetection: closestCenter,
                            onDragEnd: handleDragEnd,
                            onDragCancel: handleDragCancel,
                            onDragStart: handleDragStart,
                            modifiers: [
                                restrictToVerticalAxis
                            ],
                            children: /*#__PURE__*/ _jsx(SortableContext, {
                                items: productRow,
                                strategy: verticalListSortingStrategy,
                                children: /*#__PURE__*/ _jsxs("table", {
                                    className: "column_resize_table table1 table-striped ",
                                    style: {
                                        width: "auto"
                                    },
                                    children: [
                                        /*#__PURE__*/ _jsx("thead", {
                                            children: /*#__PURE__*/ _jsxs("tr", {
                                                children: [
                                                    /*#__PURE__*/ _jsx("th", {
                                                        children: /*#__PURE__*/ _jsx("div", {
                                                            className: "form-check form-check-st-t1",
                                                            children: customSort ? "" : /*#__PURE__*/ _jsx("input", {
                                                                className: "form-check-input",
                                                                type: "checkbox",
                                                                name: "",
                                                                onChange: function(e) {
                                                                    if (e.target.checked === true) {
                                                                        setProductRow(function(prev) {
                                                                            return prev.map(function(el) {
                                                                                return _object_spread_props(_object_spread({}, el), {
                                                                                    is_checked: true
                                                                                });
                                                                            });
                                                                        });
                                                                    } else {
                                                                        setProductRow(function(prev) {
                                                                            return prev.map(function(el) {
                                                                                return _object_spread_props(_object_spread({}, el), {
                                                                                    is_checked: false
                                                                                });
                                                                            });
                                                                        });
                                                                    }
                                                                }
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ _jsx(ColumnResizer, {
                                                        className: "columnResizer",
                                                        minWidth: 5,
                                                        defaultWidth: 35
                                                    }),
                                                    /*#__PURE__*/ _jsx("th", {
                                                        children: "รายการ"
                                                    }),
                                                    /*#__PURE__*/ _jsx(ColumnResizer, {
                                                        className: "columnResizer",
                                                        defaultWidth: 200,
                                                        minWidth: 5
                                                    }),
                                                    /*#__PURE__*/ _jsx("th", {
                                                        children: "หน่วย"
                                                    }),
                                                    /*#__PURE__*/ _jsx(ColumnResizer, {
                                                        className: "columnResizer",
                                                        minWidth: 5,
                                                        defaultWidth: 100
                                                    }),
                                                    /*#__PURE__*/ _jsx("th", {
                                                        className: "!bg-[#666CFF] !text-[#FFF]",
                                                        children: "จำนวน"
                                                    }),
                                                    /*#__PURE__*/ _jsx(ColumnResizer, {
                                                        className: "columnResizer !bg-[#666CFF] !text-[#FFF]",
                                                        minWidth: 5,
                                                        defaultWidth: 100
                                                    }),
                                                    /*#__PURE__*/ _jsx("th", {
                                                        children: "ราคา/หน่วย"
                                                    }),
                                                    /*#__PURE__*/ _jsx(ColumnResizer, {
                                                        className: "columnResizer",
                                                        minWidth: 110
                                                    }),
                                                    /*#__PURE__*/ _jsx("th", {
                                                        children: "ประเภทส่วนลด"
                                                    }),
                                                    /*#__PURE__*/ _jsx(ColumnResizer, {
                                                        className: "columnResizer",
                                                        minWidth: 5,
                                                        defaultWidth: 140
                                                    }),
                                                    /*#__PURE__*/ _jsx("th", {
                                                        className: "!bg-[#FF731D] !text-[#FFF] ",
                                                        children: "ส่วนลด"
                                                    }),
                                                    /*#__PURE__*/ _jsx(ColumnResizer, {
                                                        className: "columnResizer !bg-[#FF731D] !text-[#FFF] ",
                                                        minWidth: 5,
                                                        defaultWidth: 110
                                                    }),
                                                    /*#__PURE__*/ _jsx("th", {
                                                        className: "!bg-[#909090]  !text-[#FFF]",
                                                        children: "ภาษี"
                                                    }),
                                                    /*#__PURE__*/ _jsx(ColumnResizer, {
                                                        className: "columnResizer !bg-[#909090] !text-white",
                                                        minWidth: 5,
                                                        defaultWidth: 140
                                                    }),
                                                    /*#__PURE__*/ _jsx("th", {
                                                        children: "มูลค่าก่อนภาษี"
                                                    }),
                                                    /*#__PURE__*/ _jsx(ColumnResizer, {
                                                        className: "columnResizer",
                                                        minWidth: 5,
                                                        defaultWidth: 120
                                                    }),
                                                    /*#__PURE__*/ _jsx("th", {
                                                        children: "หัก ณ ที่จ่าย"
                                                    }),
                                                    /*#__PURE__*/ _jsx(ColumnResizer, {
                                                        className: "columnResizer",
                                                        minWidth: 5,
                                                        defaultWidth: 120
                                                    }),
                                                    /*#__PURE__*/ _jsx("th", {
                                                        children: "หมายเหตุ"
                                                    }),
                                                    /*#__PURE__*/ _jsx(ColumnResizer, {
                                                        className: "columnResizer",
                                                        minWidth: 5,
                                                        defaultWidth: 280
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx("tbody", {
                                            children: productRow.map(function(item, index) {
                                                return /*#__PURE__*/ _jsx(Productrow, {
                                                    item: item,
                                                    index: index,
                                                    columdisplay: columdisplay,
                                                    customSort: customSort,
                                                    rowCount: rowCount,
                                                    values: values,
                                                    setProductRow: setProductRow,
                                                    caseController: caseController,
                                                    optionExpense: optionExpense,
                                                    optionExpenseUnit: optionExpenseUnit,
                                                    optionWithholdingTax: optionWithholdingTax,
                                                    optionTax: optionTax,
                                                    optionsMstVat: optionsMstVat
                                                }, index);
                                            })
                                        })
                                    ]
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "mt-4 pagezoom",
                        children: /*#__PURE__*/ _jsx(Button, {
                            type: "button",
                            className: "btn-st-3 me-3",
                            onClick: function() {
                                return addProductRow(5);
                            },
                            children: "เพิ่มแถว"
                        })
                    })
                ]
            })
        ]
    });
}
export default function Productrow(_param) {
    var item = _param.item, index = _param.index, setProductRow = _param.setProductRow, columdisplay = _param.columdisplay, customSort = _param.customSort, rowCount = _param.rowCount, addProductRow = _param.addProductRow, values = _param.values, optionsMstDiscountType = _param.optionsMstDiscountType, optionsMstVat = _param.optionsMstVat, dataID = _param.dataID, caseController = _param.caseController, optionExpense = _param.optionExpense, optionExpenseUnit = _param.optionExpenseUnit, optionWithholdingTax = _param.optionWithholdingTax, optionTax = _param.optionTax, props = _object_without_properties(_param, [
        "item",
        "index",
        "setProductRow",
        "columdisplay",
        "customSort",
        "rowCount",
        "addProductRow",
        "values",
        "optionsMstDiscountType",
        "optionsMstVat",
        "dataID",
        "caseController",
        "optionExpense",
        "optionExpenseUnit",
        "optionWithholdingTax",
        "optionTax"
    ]);
    var _useSortable = useSortable({
        id: item.rowID
    }), attributes = _useSortable.attributes, listeners = _useSortable.listeners, setNodeRef = _useSortable.setNodeRef, transform = _useSortable.transform, transition = _useSortable.transition;
    var _useState = _sliced_to_array(useState(null), 2), anchorEl = _useState[0], setAnchorEl = _useState[1];
    var _useState1 = _sliced_to_array(useState(null), 2), popid = _useState1[0], setPopid = _useState1[1];
    var _item_productID, _item_productUnitID, _item_productPrice, _item_discount, _item_note;
    // console.log(item);
    return /*#__PURE__*/ _jsxs("tr", {
        className: "",
        children: [
            /*#__PURE__*/ _jsx("td", {
                style: {},
                children: /*#__PURE__*/ _jsxs("div", {
                    className: "flex items-start ",
                    children: [
                        /*#__PURE__*/ _jsxs("div", {
                            className: "mr-1",
                            children: [
                                index + 1,
                                ". "
                            ]
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "form-check form-check-st-t1",
                            children: /*#__PURE__*/ _jsx("input", {
                                className: "form-check-input",
                                type: "checkbox",
                                name: "",
                                checked: item.is_checked,
                                onChange: function(e) {
                                    if (e.target.checked === true) {
                                        setProductRow(function(prev) {
                                            return prev.map(function(el) {
                                                if (el.rowID === item.rowID) {
                                                    return _object_spread_props(_object_spread({}, el), {
                                                        is_checked: true
                                                    });
                                                }
                                                return el;
                                            });
                                        });
                                    } else {
                                        setProductRow(function(prev) {
                                            return prev.map(function(el) {
                                                if (el.rowID === item.rowID) {
                                                    return _object_spread_props(_object_spread({}, el), {
                                                        is_checked: false
                                                    });
                                                }
                                                return el;
                                            });
                                        });
                                    }
                                }
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsx("td", {
                className: "column_resizer_body"
            }),
            /*#__PURE__*/ _jsx("td", {
                children: /*#__PURE__*/ _jsxs("select", {
                    value: (_item_productID = item.productID) !== null && _item_productID !== void 0 ? _item_productID : "",
                    style: {
                        width: "100%",
                        border: "1px solid rgb(223, 225, 229)"
                    },
                    onChange: function(e) {
                        setProductRow(function(prev) {
                            return prev.map(function(el) {
                                if (el.rowID === item.rowID) {
                                    return _object_spread_props(_object_spread({}, el), {
                                        productID: e.currentTarget.value
                                    });
                                }
                                return el;
                            });
                        });
                    },
                    className: "form-control sselectv",
                    children: [
                        /*#__PURE__*/ _jsx("option", {
                            value: "",
                            disabled: true,
                            children: "เลือกค่าใช้จ่าย"
                        }, "default"),
                        optionExpense && optionExpense.map(function(v, index) {
                            return /*#__PURE__*/ _jsx("option", {
                                value: v.value,
                                children: v.label
                            }, index);
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsx("td", {
                className: "column_resizer_body"
            }),
            /*#__PURE__*/ _jsx("td", {
                children: /*#__PURE__*/ _jsxs("select", {
                    value: (_item_productUnitID = item.productUnitID) !== null && _item_productUnitID !== void 0 ? _item_productUnitID : "",
                    style: {
                        width: "100%",
                        border: item.productID && !item.productUnitID ? "1px solid #dc3545" : "1px solid rgb(223, 225, 229)"
                    },
                    onChange: function(e) {
                        setProductRow(function(prev) {
                            return prev.map(function(el) {
                                if (el.rowID === item.rowID) {
                                    return _object_spread_props(_object_spread({}, el), {
                                        productUnitID: e.currentTarget.value
                                    });
                                }
                                return el;
                            });
                        });
                    },
                    className: "form-control sselectv",
                    children: [
                        /*#__PURE__*/ _jsx("option", {
                            value: "",
                            disabled: true,
                            children: "เลือกหน่วย"
                        }, "default"),
                        optionExpenseUnit && optionExpenseUnit.map(function(v, index) {
                            return /*#__PURE__*/ _jsx("option", {
                                value: v.value,
                                children: v.label
                            }, index);
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsx("td", {
                className: "column_resizer_body"
            }),
            /*#__PURE__*/ _jsx("td", {
                className: "!bg-[#EDEDFF] !text-[#666CFF] !pl-1",
                children: item.productID != "" ? /*#__PURE__*/ _jsx("input", {
                    type: "number",
                    className: "form-control formv text-center me-2",
                    value: item.productQty,
                    style: {
                        width: "100%",
                        border: item.productID && !item.productQty ? "1px solid #dc3545" : "1px solid rgb(223, 225, 229)"
                    },
                    onChange: function(e) {
                        setProductRow(function(prev) {
                            return prev.map(function(el) {
                                if (el.rowID === item.rowID) {
                                    return _object_spread_props(_object_spread({}, el), {
                                        productQty: e.target.value
                                    });
                                }
                                return el;
                            });
                        });
                    }
                }) : ""
            }),
            /*#__PURE__*/ _jsx("td", {
                className: "column_resizer_body !bg-[#EDEDFF] !text-[#666CFF]"
            }),
            /*#__PURE__*/ _jsx("td", {
                children: item.productID ? /*#__PURE__*/ _jsx(CurrencyInput, {
                    placeholder: "",
                    defaultValue: (_item_productPrice = item.productPrice) !== null && _item_productPrice !== void 0 ? _item_productPrice : 0,
                    value: item.productPrice,
                    decimalsLimit: 4,
                    // fixedDecimalLength={2}
                    decimalScale: 4,
                    onValueChange: function(value, name, values) {
                        // console.log(value);
                        setProductRow(function(prev) {
                            return prev.map(function(el) {
                                if (el.rowID === item.rowID) {
                                    return _object_spread_props(_object_spread({}, el), {
                                        productPrice: value
                                    });
                                }
                                return el;
                            });
                        });
                    },
                    className: "form-control formv text-end me-2"
                }) : ""
            }),
            /*#__PURE__*/ _jsx("td", {
                className: "column_resizer_body"
            }),
            /*#__PURE__*/ _jsxs("td", {
                className: "position-reative",
                id: "pop".concat(index),
                children: [
                    /*#__PURE__*/ _jsxs("button", {
                        className: "btn w-100 btn-nhover",
                        type: "button",
                        id: "idd".concat(index),
                        style: {
                            height: "34px"
                        },
                        variant: "contained",
                        onClick: function(e) {
                            setPopid("sss2".concat(index));
                            setAnchorEl(e.currentTarget);
                        },
                        children: [
                            item.productID && (item.discount > 0 || item.discountType == 2) && /*#__PURE__*/ _jsx(_Fragment, {
                                children: item.discountType == 1 ? "".concat(item.discountPercent, " %") : item.discountType == 2 ? "บาท" : ""
                            }),
                            item.productID && !(item.discount > 0 || item.discountType == 2) && /*#__PURE__*/ _jsx("div", {
                                style: {
                                    color: "#565DFF"
                                },
                                children: "เลือกส่วนลด"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx(Popover, {
                        id: "sss2".concat(index),
                        open: "sss2".concat(index) == popid,
                        anchorEl: anchorEl,
                        onClose: function() {
                            setAnchorEl(null);
                            setPopid(null);
                        },
                        anchorPosition: {
                            left: 0,
                            top: 0
                        },
                        container: document.getElementById("pop".concat(index)),
                        children: /*#__PURE__*/ _jsxs("div", {
                            className: "p-3 text-start ",
                            style: {
                                width: "260px",
                                height: "160px"
                            },
                            children: [
                                /*#__PURE__*/ _jsx("div", {
                                    className: "mb-3",
                                    children: "เลือกรูปแบบส่วนลด"
                                }),
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "mb-2 d-flex align-items-center",
                                    children: [
                                        /*#__PURE__*/ _jsx(Form.Check, {
                                            inline: true,
                                            label: "เปอร์เซ็นต์ %",
                                            name: "",
                                            type: "radio",
                                            id: "x-radio-2".concat(index),
                                            className: "form-check-st-2 tc-7",
                                            checked: item.discountType == 1,
                                            onChange: function(e) {
                                                setProductRow(function(prev) {
                                                    return prev.map(function(el) {
                                                        if (el.rowID === item.rowID) {
                                                            return _object_spread_props(_object_spread({}, el), {
                                                                discountType: 1,
                                                                discount: el.productPrice * parseFloat(el.discountPercent) / 100
                                                            });
                                                        }
                                                        return el;
                                                    });
                                                });
                                            }
                                        }),
                                        /*#__PURE__*/ _jsx(Form.Control, {
                                            type: "number",
                                            name: "",
                                            className: "form-control text-center",
                                            placeholder: "",
                                            value: item.discountPercent,
                                            style: {
                                                width: "60px"
                                            },
                                            onChange: function(e) {
                                                setProductRow(function(prev) {
                                                    return prev.map(function(el) {
                                                        if (el.rowID === item.rowID) {
                                                            return _object_spread_props(_object_spread({}, el), {
                                                                discountPercent: e.target.value,
                                                                discount: el.productPrice * parseFloat(e.target.value) / 100
                                                            });
                                                        }
                                                        return el;
                                                    });
                                                });
                                            }
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    children: /*#__PURE__*/ _jsx(Form.Check, {
                                        inline: true,
                                        label: "บาท",
                                        name: "",
                                        type: "radio",
                                        id: "x-radio-1".concat(index),
                                        className: "form-check-st-2 tc-7",
                                        checked: item.discountType == 2,
                                        onChange: function(e) {
                                            setProductRow(function(prev) {
                                                return prev.map(function(el) {
                                                    if (el.rowID === item.rowID) {
                                                        return _object_spread_props(_object_spread({}, el), {
                                                            discountType: 2
                                                        });
                                                    }
                                                    return el;
                                                });
                                            });
                                        }
                                    })
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("td", {
                className: "column_resizer_body"
            }),
            /*#__PURE__*/ _jsx("td", {
                className: "!bg-[#FFEDE0] !text-[#FF731D] !pl-1",
                children: item.productID && item.discountType == 1 ? /*#__PURE__*/ _jsx(NumericFormat, {
                    displayType: "text",
                    thousandSeparator: ",",
                    decimalScale: 4,
                    fixedDecimalScale: true,
                    value: item.productPrice * parseFloat(item.discountPercent) / 100
                }) : item.productID && item.discountType == 2 ? /*#__PURE__*/ _jsx(CurrencyInput, {
                    placeholder: "",
                    defaultValue: (_item_discount = item.discount) !== null && _item_discount !== void 0 ? _item_discount : 0,
                    value: values.discount,
                    decimalsLimit: 4,
                    // fixedDecimalLength={2}
                    decimalScale: 4,
                    onValueChange: function(value, name, values) {
                        setProductRow(function(prev) {
                            return prev.map(function(el) {
                                if (el.rowID === item.rowID) {
                                    return _object_spread_props(_object_spread({}, el), {
                                        discount: value
                                    });
                                }
                                return el;
                            });
                        });
                    },
                    className: "form-control formv text-end me-2"
                }) : ""
            }),
            /*#__PURE__*/ _jsx("td", {
                className: "column_resizer_body !bg-[#FFEDE0] !text-[#FF731D]"
            }),
            /*#__PURE__*/ _jsx("td", {
                className: " !text-[#DC0000] !pl-1",
                children: item.productID ? /*#__PURE__*/ _jsx("select", {
                    style: {
                        width: "100%"
                    },
                    value: item.dim_mst_vat_id,
                    onChange: function(e) {
                        setProductRow(function(prev) {
                            return prev.map(function(el) {
                                if (el.rowID === item.rowID) {
                                    var vat = optionsMstVat.find(function(v) {
                                        return v.value == e.currentTarget.value;
                                    });
                                    vat = vat ? vat.vat : 0;
                                    return _object_spread_props(_object_spread({}, el), {
                                        dim_mst_vat_id: e.currentTarget.value,
                                        vat: vat
                                    });
                                }
                                return el;
                            });
                        });
                    },
                    className: "form-control sselectv",
                    children: optionsMstVat && optionsMstVat.map(function(v, index) {
                        return /*#__PURE__*/ _jsx("option", {
                            value: v.value,
                            children: v.label
                        }, index);
                    })
                }) : ""
            }),
            /*#__PURE__*/ _jsx("td", {
                className: "column_resizer_body  !text-[#DC0000]"
            }),
            /*#__PURE__*/ _jsx("td", {
                children: item.productID ? /*#__PURE__*/ _jsx(NumericFormat, {
                    displayType: "text",
                    thousandSeparator: ",",
                    decimalScale: 2,
                    fixedDecimalScale: true,
                    value: calPriceByMstCategoryPriceTax(item, values.dim_mst_price_category_id, true)
                }) : ""
            }),
            /*#__PURE__*/ _jsx("td", {
                className: "column_resizer_body"
            }),
            /*#__PURE__*/ _jsx("td", {
                className: "!pl-1",
                children: item.productID ? /*#__PURE__*/ _jsxs("select", {
                    style: {
                        width: "100%"
                    },
                    value: item.dim_mst_withholding_tax_id,
                    onChange: function(e) {
                        setProductRow(function(prev) {
                            return prev.map(function(el) {
                                if (el.rowID === item.rowID) {
                                    return _object_spread_props(_object_spread({}, el), {
                                        dim_mst_withholding_tax_id: e.currentTarget.value
                                    });
                                }
                                return el;
                            });
                        });
                    },
                    className: "form-control sselectv",
                    children: [
                        /*#__PURE__*/ _jsx("option", {
                            value: "",
                            children: "ไม่มี"
                        }, "default"),
                        optionWithholdingTax && optionWithholdingTax.map(function(v, index) {
                            return /*#__PURE__*/ _jsx("option", {
                                value: v.value,
                                children: v.label
                            }, index);
                        })
                    ]
                }) : ""
            }),
            /*#__PURE__*/ _jsx("td", {
                className: "column_resizer_body"
            }),
            /*#__PURE__*/ _jsx("td", {
                children: item.productID ? /*#__PURE__*/ _jsx("input", {
                    type: "text",
                    className: "form-control formv text-start border-0 me-2",
                    value: (_item_note = item.note) !== null && _item_note !== void 0 ? _item_note : "",
                    onChange: function(e) {
                        setProductRow(function(prev) {
                            return prev.map(function(el) {
                                if (el.rowID === item.rowID) {
                                    return _object_spread_props(_object_spread({}, el), {
                                        note: e.target.value
                                    });
                                }
                                return el;
                            });
                        });
                    }
                }) : ""
            }),
            /*#__PURE__*/ _jsx("td", {
                className: "column_resizer_body"
            })
        ]
    });
}
